import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, Loader } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
`;

const AppLoader: React.FC = () => (
  <LoaderWrapper>
    <Loader size="large" />
  </LoaderWrapper>
);

export default AppLoader;
